<mat-form-field appearance="outline" subscriptSizing="dynamic" [floatLabel]="selectedElements.length > 0 ? 'always' : 'auto'">
  <mat-label>Assign to team{{ required ? '*' : '' }}</mat-label>
  <mat-chip-grid #elementsList [errorStateMatcher]="errorStateMatcher">
    @for (element of selectedElements; track element.id) {
      <la-team-chip-editable [color]="element.color" [removable]="true" (remove)="remove(element)">
        {{ element.name }}
      </la-team-chip-editable>
    }

    <input
      #elementsInput
      placeholder="Assign to team"
      [formControl]="inputControl"
      [matAutocomplete]="auto"
      [matChipInputFor]="elementsList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur"
      (matChipInputTokenEnd)="add($event)"
      (blur)="onInputBlur()"
      [style.display]="canAddTeams ? '' : 'none'"
    />
  </mat-chip-grid>
  <mat-error>At least one team is required</mat-error>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="select($event)">
    @for (element of autocompleteElements$ | async; track element.id) {
      <mat-option [value]="element">
        {{ element.name }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
